import ActionModal from '../../../../../components/action-modal';
import { InfoIcon } from '../../../../../assets/images';
import type { PiiScan } from '../../types/api-types';

type PiiUploadConfirmationModalProps = {
  open: boolean;
  piiScan: PiiScan | null;
  onConfirm: () => void;
  onCancel: () => void;
};

function PiiUploadConfirmationModal({
  open,
  piiScan,
  onConfirm,
  onCancel,
}: PiiUploadConfirmationModalProps) {
  const detectedItems = piiScan?.detected_pii?.filter((item) => (item.count ?? 0) > 0) ?? [];
  const enabledItems = piiScan?.enabled_pii ?? [];

  return (
    <ActionModal
      className="w-[480px]"
      open={open}
      modalTitle="PII Detected"
      modalDesc="We noticed some personal information in your file. Rest assured, we automatically mask this data so the AI never sees your actual details. Would you like to proceed with the upload?"
      modalLogo={InfoIcon}
      resetData={onCancel}
      saveData={onConfirm}
      confirmButtonText="Yes, Continue"
      cancelButtonText="No, Cancel"
    >
      <div className="flex flex-col gap-4 pt-2">
        {detectedItems.length > 0 && (
          <div>
            <p className="text-sm font-semibold text-[#101828] mb-2">Detected PIIs</p>
            <ul className="flex flex-col gap-1.5">
              {detectedItems.map((item) => (
                <li
                  key={item.type}
                  className="flex items-center justify-between text-sm text-[#344054] bg-[#FEF3F2] border border-[#FECDCA] rounded-lg px-3 py-2"
                >
                  <span>{item.label}</span>
                  <span className="font-medium text-[#B42318]">{item.count}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {enabledItems.length > 0 && (
          <div>
            <p className="text-sm font-semibold text-[#101828] mb-2">Enabled PIIs</p>
            <ul className="grid grid-cols-2 gap-2">
              {enabledItems.map((item) => (
                <li
                  key={item.type}
                  className="text-sm text-[#344054] bg-[#F9FAFB] border border-[#E4E7EC] rounded-lg px-3 py-2"
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </ActionModal>
  );
}

export default PiiUploadConfirmationModal;
